import { useNavigate } from 'react-router-dom';

export default function QuizPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <header className="bg-white sticky top-0 z-10 border-b border-gray-100 shadow-sm">
        <div className="max-w-md mx-auto px-4 h-14 flex items-center">
          <button
            onClick={() => navigate('/learning')}
            className="w-10 h-10 flex items-center justify-center -ml-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <h1 className="flex-1 text-center font-bold text-gray-800 pr-8 text-base">
            小テスト
          </h1>
        </div>
      </header>

      <main className="max-w-md mx-auto px-4 py-6">
        <div className="bg-white rounded-2xl p-8 shadow-sm text-center space-y-4">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#F4B183]/30 rounded-full text-[#C05621] text-2xl">
            <i className="ri-quill-pen-line"></i>
          </div>
          <h2 className="text-lg font-bold text-gray-800">準備中です</h2>
          <p className="text-sm text-gray-500 leading-relaxed">
            小テストのコンテンツは現在準備中です。公開まで今しばらくお待ちください。
          </p>
        </div>
      </main>
    </div>
  );
}

